import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PricesObj } from 'src/app/models/beat-list-model';
import { LicenceDataModel } from 'src/app/models/lic-list.model';
import { LicenseSlug } from 'src/app/models/selected-files-data';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Pipe({
  name: 'checkExclusiveLic'
})
export class CheckExclusiveLic implements PipeTransform {
  licenceData:any = [];
  constructor(private beatService: BeatsService,
    private browserService: BrowserStorageService) {
  }
  transform(priceData: Array<PricesObj>): any {
    let finalPrice:any = {
      isShowExckusive: false,
      exclusiveData: ""
    };
    let foundData = "";
    if (this.browserService.getLicData().length > 0) {
      this.licenceData = this.browserService.getLicData();
      foundData = this.checkExclusive(priceData);
    } else {
      this.beatService.getLicence().subscribe((res: Array<LicenceDataModel>) => {
        this.licenceData = res;
        foundData = this.checkExclusive(priceData);
     });
    }
    if (foundData) {
      finalPrice['isShowExclusive'] = true;
      finalPrice['exclusiveData'] = foundData;
    }
    return finalPrice;
  }

  checkExclusive(priceData: Array<PricesObj>) {
    let finalPrice: any = "";
    let selectedLicSlug: any = "";
    selectedLicSlug = LicenseSlug.Exclusive;
    if (priceData.length > 0) {
      for (let data of this.licenceData) {
        let found: any = "";
        found = priceData.find(item => item.licence === data._id && selectedLicSlug === data.slug);
        if (found) {
          finalPrice = found;
            break;
        }
      }
    }
    return finalPrice;
  }
}
